import type { IState } from '../state';
import { IAction } from '../actionTypes';
import space from '../namespace';
import appReducer from './app';
import homeReducer from './home';
import activityReducer from './activity'
import detailReducer from './detail';
import squareReducer from './square';
import editReducer from './edit';
import consultReducer from './consult';
import devicesReducer from './devices';
import deviceRedcuer from './device';
import profileRedcuer from './profile';
import groupRedcuer from './group';
import searchRedcuer from './search';
import userCenterReducer from './userCenter';

const reducers = {
  [space.app]: appReducer,
  [space.home]: homeReducer,
  [space.detail]: detailReducer,
  [space.activity]: activityReducer,
  [space.square]: squareReducer,
  [space.edit]: editReducer,
  [space.consult]: consultReducer,
  [space.devices]: devicesReducer,
  [space.device]: deviceRedcuer,
  [space.profile]: profileRedcuer,
  [space.group]: groupRedcuer,
  [space.search]: searchRedcuer,
  [space.userCenter]: userCenterReducer,
};

const reducer = (state: IState, action: IAction<any>): IState => {
  const { namespace = space.app } = action;
  return reducers[namespace](state, (action as any));
};

export default reducer;
